import formatCycleRuntime from '@shared/lib/formatter/formatCycleRuntime';
import moment from 'moment/moment';
import convertToCelsius from '@shared/lib/converter/convertToCelsius';
import convertToCelsiusResult from '@shared/lib/converter/convertToCelsiusResult';

const formatCycleList = (cycleList, unitSettings, zoneMap) => {
  const { TEMP_UNIT = '°F', PRESSURE_UNIT = 'inH2O' } = unitSettings;

  return cycleList.map((cycle) => {
    const {
      acMode,
      uid,
      tempAPI,
      rhAPI,
      pressureChange,
      deltaT,
      returnAir,
      atticAir,
      startTime,
      cycleTimeSeconds,
      supplyAir,
      dtPayload: { sup, ret } = {},
    } = cycle;

    const pressureConversion = 248.84;
    let zone;
    let deltaP = 0;
    let performance = deltaT;
    let supplyAirTemp = acMode === 'Cool' ? supplyAir.minTemp : supplyAir.maxTemp;
    let leakTemp = acMode === 'Cool' ? atticAir.minTemp : atticAir.maxTemp;
    let returnAirTemp = acMode === 'Cool' ? returnAir.minTemp : returnAir.maxTemp;
    let oaTemp = tempAPI;
    const rh = rhAPI || '--';

    if (sup) {
      supplyAirTemp = sup;
    }
    if (ret) {
      returnAirTemp = ret;
    }

    if (TEMP_UNIT === '°C') {
      oaTemp = convertToCelsius(tempAPI);
      leakTemp = convertToCelsius(leakTemp);
      performance = convertToCelsiusResult(deltaT);
      supplyAirTemp = convertToCelsius(supplyAirTemp);
      returnAirTemp = convertToCelsius(returnAirTemp);
    }

    if (supplyAir && supplyAir.deviceId) {
      let serialNumber = uid;
      if (!serialNumber.includes('-')) {
        serialNumber = `${uid}-${supplyAir.deviceId}`;
      }
      zone = zoneMap ? zoneMap[serialNumber] : '--';
    }

    if (pressureChange && pressureChange.onChange) {
      if (PRESSURE_UNIT === 'inH2O') {
        deltaP = `${Math.abs(pressureChange.onChange / pressureConversion).toFixed(2)}inH2O`;
      } else {
        deltaP = `${pressureChange.onChange}Pa`;
      }
    }
    const p = Math.abs(performance.toFixed(0));
    if (acMode === 'Cool') {
      performance = `-${p}${TEMP_UNIT}`;
    } else if (acMode === 'Heat') {
      performance = `+${p}${TEMP_UNIT}`;
    } else {
      performance = `${p}${TEMP_UNIT}`;
    }
    return {
      acMode,
      zone,
      oaTemp: `${oaTemp}${TEMP_UNIT}/${rh}`,
      deltaP,
      performance,
      supRet: `${supplyAirTemp.toFixed(0)}${TEMP_UNIT}/${returnAirTemp.toFixed(0)}${TEMP_UNIT}`,
      leakTemp: leakTemp ? `${leakTemp}${TEMP_UNIT}` : '--',
      runtime: formatCycleRuntime(cycleTimeSeconds),
      date: moment(startTime).format('MMM DD, YYYY | h:mm A'),
    };
  });
};

export default formatCycleList;
